import { useFormStore } from "~/store/formStore";

export const accountFormStore = useFormStore("account");
export const signFormStore = useFormStore("sign");
